import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { WUExtendPropsType, initDataType } from '../../system/WebUniversalNewEx';
import MenuWarehouseEdit from './MenuWarehouseEdit';
import MenuWarehouseIngredient from '../ingredient/MenuWarehouseIngredient';
// import CopyMenuWarehouse from './CopyMenuWarehouse';
import MenuWarehouseSpec from './MenuWarehouseSpec';
import MenuIntroduction from './MenuIntroduction';
import MenuMovie from './MenuMovie';
import MenuWarehouseUploadFile from './MenuWarehouseUploadFile';
import { useContext, useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Modal, Radio, Row, Select, Space, Timeline, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';
import { SocketContext } from '../../../App';
import DownloadExcel from '../../report/DownloadExcel';
import getList from '../../universal/getList';
// import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';

export default function MenuWarehouse(props: any) {

    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const apiId = "menuWarehouse";
    // const notificationApi = useNotificationInstance();

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    //规格窗口
    const [menuWarehouseSpecVisible, setMenuWarehouseSpecVisible] = useState(false);

    //介绍窗口setMenuIntroductionVisible
    const [menuIntroductionVisible, setMenuIntroductionVisible] = useState(false);

    //介绍数据
    const [menuIntroductionData, setMenuIntroductionData] = useState<any>();

    //视频窗口setMenuIntroductionVisible
    const [menuMovieVisible, setMenuMovieVisible] = useState(false);

    //历程窗口
    const [historyVisible, setHistoryVisible] = useState(false);

    //历程数据
    const [historyData, setHistoryData] = useState();

    //主配料窗口
    const [menuWarehouseIngredientVisible, setMenuWarehouseIngredientVisible] = useState(false);

    //品牌数据
    const [brandData, setBrandData] = useState();

    //大分类数据
    const [menuWarehouseCategoryData, setMenuWarehouseCategoryData] = useState();

    //小分类数据
    const [menuWarehouseTypeData, setMenuWarehouseTypeData] = useState();

    //出品部门数据
    const [menuWarehouseDepartmentData, setMenuWarehouseDepartmentData] = useState();

    //导出菜式参数
    // const [downloadData, setDownloadData] = useState<any>();

    /** 显示菜谱类型数据 */
    const [showDownLoadModalVisible, setShowDownLoadModalVisible] = useState<any>(false);

    // //复制菜式窗口
    // const [copyMenuWarehouseVisible, setCopyMenuWarehouseVisible] = useState(false);

    // //复制菜式数据
    // const [copyMenuWarehouseData, setCopyMenuWarehouseData] = useState<any>();

    //规格数据
    const [specData, setSpecData] = useState<any>();

    //仓库ID
    const [menuWarehouseId, setMenuWarehouseId] = useState<any>();

    //主配料数据
    const [ingredientData, setIngredientData] = useState<any>();

    const [menuWarehouseCategoryId, setMenuWarehouseCategoryId] = useState<any>();
    const [menuWarehouseTypeId, setMenuWarehouseTypeId] = useState<any>();
    const [menuWarehouseDepartmentId, setMenuWarehouseDepartmentId] = useState<any>();
    const [menuWarehouseTypeValue, setMenuWarehouseTypeValue] = useState<any>();
    const [defaultCategoryId, setDefaultCategoryId] = useState<any>();
    const [isComplete, setIsComplete] = useState<any>();

    const [opusNumberBefore, setOpusNumberBefore] = useState<any>();
    const [opusNumberBefores, setOpusNumberBefores] = useState<any>([
        {
            value: "GZ",
            label: "GZ"
        },
        {
            value: "SH",
            label: "SH"
        }
    ]);

    const isCompleteOptions = [
        { label: '仅看没内容', value: '1' },
        { label: '仅看有内容', value: '2' },
        { label: '全部显示', value: '3' },
    ];

    const [loadingData, setLoadingData] = useState<any>(false);

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "brand",
                apiExtend: 'showList',
            }).then(res => {
                if (res.success) {
                    setBrandData(res.data);
                }
            })

            fetchApi.GET(wmService, {
                apiId: "menuWarehouseCategory",
                apiExtend: 'showList',
            }).then(res => {
                if (res.success) {
                    setMenuWarehouseCategoryData(res.data);
                }
            })

            fetchApi.GET(wmService, {
                apiId: "menuWarehouseDepartment",
                apiExtend: 'showList',
            }).then(res => {
                if (res.success) {
                    setMenuWarehouseDepartmentData(res.data);
                }
            })
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //传关参数
    let sendData = {
        type: 'EDIT',
        id: '',
        foodName: '',
        path: 'MenuWarehouse',
        key: '',
        brandId: ''
    }

    const initData = async () => {
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                opusNumberBefore,
                menuWarehouseTypeId,
                menuWarehouseCategoryId,
                menuWarehouseDepartmentId,
                isComplete
            }
        }
        ref.current.initData(currentData);
    }

    //关闭仓库菜式规格页面
    const onCloseMenuWarehouseSpec = async (status: boolean) => {
        setMenuWarehouseSpecVisible(false);
        if (status) {
            await initData();
        }
    }

    //打开介绍窗口
    const handleIntroduction = (record: any) => {
        //console.log(record);
        sendData.id = record.id;
        sendData.foodName = record.foodName;
        setMenuIntroductionData(sendData);
        setMenuIntroductionVisible(true);
    };

    //关闭介绍窗口
    const onCloseMenuIntroduction = async (status: boolean) => {
        setMenuIntroductionVisible(false);
        if (status) {
            await initData();
        }
    }

    //打开视频窗口
    const handleMenuMovie = (record: any) => {
        //console.log(record);
        setMenuWarehouseId(record.id);
        setMenuMovieVisible(true);
    };

    //关闭视频页面
    const onCloseMenuMovie = async (status: boolean) => {
        setMenuMovieVisible(false);
        // if (status) {
        //     await initData();
        // }
    }

    //打开规格窗口
    const handleMenuWarehouseSpec = (record: any) => {
        //console.log(record);
        sendData.id = record.id;
        sendData.foodName = record.foodName;
        setSpecData(sendData);
        setMenuWarehouseSpecVisible(true);
    };

    //打开历程窗口
    const handleHistory = (record: any) => {
        fetchApi.GET(wmService, {
            apiId: "menuWarehouse",
            apiExtend: 'checkHistory',
            apiData: {
                data: record,
                id: record.id,
                superiorMenuWarehouseId: record.superiorMenuWarehouseId,
                version: record.version
            }
        }).then(res => {
            if (res.success) {
                let newDatas: any = [];
                for (var j = 0; j < res.data.length; j++) {
                    newDatas.push({
                        children: (<>
                            <p>{res.data[j].foodName}</p>
                            <p>{res.data[j].created ? res.data[j].created + "年创于" + res.data[j].area.areaName : ""}</p>
                        </>)
                        ,
                        label: res.data[j].version,
                        color: record.id === res.data[j].id ? 'red' : 'blue'
                    })
                }
                setHistoryData(newDatas);
            }
        });

        setHistoryVisible(true);
    };

    //关闭历程窗口
    const onCloseHistory = () => {
        setHistoryVisible(false);
    }

    // //改变数据
    // const handleChange = async (id: any, columnName: string, value: boolean) => {
    //     const bodys = {
    //         apiId: "menuWarehouse",
    //         apiVariable: id,
    //         apiExtend: "updateOne",
    //         apiData: {
    //             columnName,
    //             value
    //         }
    //     }

    //     fetchApi.PUT(wmService, bodys).then(res => {
    //         showCustomNotification(notificationApi!, {
    //             type: 'success',
    //             message: '编辑成功',
    //             description: 'success',
    //         });;
    //         initData();
    //     }).catch(err => {
    //         antMessage('error', '删编辑失败', err.message);
    //     })
    // };

    //关闭主配料页面
    const onCloseIngredient = async (status: boolean) => {
        setMenuWarehouseIngredientVisible(false);
        // if (status) {
        //     await initData();
        // }
    }

    //打开添加主配料
    const handleIngredient = async (record: any) => {
        // console.log(record);
        // await fetchApi.POST(wmService, {
        //     apiId: 'menuWarehouseIngredientDetail',
        //     apiExtend: 'updatePrice',
        //     apiData: {
        //         menuWarehouseId: record.id,
        //         apiId,
        //         key: 'MenuWarehouse'
        //     }
        // }).then(res => {
        //     if (res.success) {
        //         console.log(res.data);
        //     }
        // });

        sendData.id = record.id;
        sendData.foodName = record.foodName;
        setIngredientData(sendData);
        setMenuWarehouseIngredientVisible(true);
    };

    //表头
    const columnsHead = [
        // {
        //     title: '品牌',
        //     dataIndex: 'brandName',
        //     render: (text: any, record: any) => {
        //         return (
        //             <div>{record.brand.brandName}</div>
        //         )
        //     }
        // },
        {
            title: '作品号',
            dataIndex: 'opusNumber',
            sorter: true
        },
        {
            title: '大分类',
            dataIndex: 'menuWarehouseCategory',
            render: (text: any, record: any) => {
                return (
                    <div>{record.menuWarehouseType.menuWarehouseCategory.menuWarehouseCategoryName}</div>
                )
            }
        },
        {
            title: '小分类',
            dataIndex: 'menuWarehouseType',
            render: (text: any, record: any) => {
                return (
                    <div>{text.menuWarehouseTypeName}</div>
                )
            }
        },
        {
            title: '烹调方法',
            dataIndex: 'cookMethod',
            render: (text: any, record: any) => {
                return (
                    <div>{text.cookMethodName}</div>
                )
            }
        },
        {
            title: '菜式名称',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                return (
                    <Tooltip placement="topLeft" title={record.foodNameEn ? record.foodNameEn : ""}>
                        <div>{text}</div>
                    </Tooltip>
                )
            }
        },
        {
            title: '创作时间地区',
            dataIndex: 'created',
            render: (text: any, record: any) => {
                if (text) {
                    return (
                        <div>{text + "年创于" + record.area.areaName}</div>
                    )
                }
            }
        },
        {
            title: '规格',
            dataIndex: 'menuWarehouseSpec',
            key: 'menuWarehouseSpec',
            render: (text: any, record: any) => {
                if (record.menuWarehouseSpecs.length > 0) {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" onClick={() => handleMenuWarehouseSpec(record)}>规格</Button>
                        </Space>
                    )
                }
                else {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" danger onClick={() => handleMenuWarehouseSpec(record)}>规格</Button>
                        </Space>
                    )
                }
            }
        },
        {
            title: '主配料',
            dataIndex: 'ingredient',
            key: 'ingredient',
            render: (text: any, record: any) => {
                if (record.menuWarehouseSpecs.length > 0) {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" onClick={() => handleIngredient(record)}>主配料</Button>
                        </Space>
                    )
                }
            }
        },
        {
            title: "介绍",
            dataIndex: "introduction",
            render: (text: any, record: any) => {
                if (record.menuIntroductions.length > 0) {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" onClick={() => handleIntroduction(record)}>介绍</Button>
                        </Space>
                    )
                }
                else {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" danger onClick={() => handleIntroduction(record)}>介绍</Button>
                        </Space>
                    )
                }
            }
        },
        {
            title: '视频',
            dataIndex: 'movie',
            key: 'movie',
            render: (text: any, record: any) => {
                return (
                    <Space size="small">
                        <Button size={"small"} type="primary" onClick={() => handleMenuMovie(record)}>视频</Button>
                    </Space>
                )
            }
        },
        {
            title: "历程",
            dataIndex: "history",
            render: (text: any, record: any) => {
                return (
                    <Button size={"small"} type="primary" onClick={() => handleHistory(record)}>历程</Button>
                )
            }
        },
        // {
        //     title: '复制',
        //     dataIndex: 'copy',
        //     key: 'copy',
        //     render: (text: any, record: any) => {
        //         if (record.menuWarehouseSpecs.length > 0) {
        //             return (
        //                 <Tooltip placement="topLeft" title={'复制【' + record.foodName + '】到其他品牌'}>
        //                     <Space size="small">
        //                         <Button size={"small"} type="primary" onClick={() => handleCopy(record, 'single')}>复制</Button>
        //                     </Space>
        //                 </Tooltip>
        //             )
        //         }
        //     }
        // },
        // {
        //     title: '排序',
        //     dataIndex: 'sortBy',
        // },
    ];


    // /**
    //  * 复制菜式
    //  * @param id 
    //  */

    // const handleCopy = (record: any, key: any) => {

    //     if (key === 'single') {
    //         sendData.id = record.id;
    //         sendData.foodName = record.foodName;
    //         sendData.brandId = record.brand.id;
    //     }
    //     sendData.key = key;
    //     setCopyMenuWarehouseData(sendData);
    //     setCopyMenuWarehouseVisible(true);

    //     // fetchApi.POST(wmService, {
    //     //     apiId: 'menuWarehouse',
    //     //     apiExtend: 'copy',
    //     //     apiVariable: record.id
    //     // }).then(res => {
    //     //     console.log(res.data);
    //     // })
    // };

    //打开导出文档窗口
    const handleDownloadExcel = async (e: any) => {
        setShowDownLoadModalVisible(true);
    };

    //关闭导出文档窗口
    const onCloseDownLoadModal = () => {
        setShowDownLoadModalVisible(false);
        form.setFieldsValue({ menuWarehouseCategoryIds: null });
        form.setFieldsValue({ brandIds: null });
    }

    //查看不同作品号前缀/大分类/小分类/出品部门的菜式
    const selectChange = async (e: any, key: any, setData: any) => {
        let refresh = true;
        setData(e);
        if (key === 'menuWarehouseCategory') {
            refresh = await getCategoryToTypeData(e);
        }
        if (key === 'menuWarehouseType') {
            setMenuWarehouseTypeValue(e);
        }

        if (refresh) {
            const currentData: initDataType = {
                apiId,
                sendPageData: {
                    opusNumberBefore: key === 'opusNumberBefore' ? e : opusNumberBefore,
                    menuWarehouseTypeId: key === 'menuWarehouseType' ? e : menuWarehouseTypeId,
                    menuWarehouseCategoryId: key === 'menuWarehouseCategory' ? e : menuWarehouseCategoryId,
                    menuWarehouseDepartmentId: key === 'menuWarehouseDepartment' ? e : menuWarehouseDepartmentId,
                    isComplete
                }
            }
            ref.current.initData(currentData);
        }
    }

    const getCategoryToTypeData = (menuWarehouseCategoryId: string) => {
        if (menuWarehouseCategoryId !== defaultCategoryId) {
            setMenuWarehouseTypeValue(undefined);
            setMenuWarehouseTypeId(undefined);

            const currentData: initDataType = {
                apiId,
                sendPageData: {
                    menuWarehouseTypeId: undefined,
                    menuWarehouseCategoryId,
                    opusNumberBefore,
                    menuWarehouseDepartmentId,
                    isComplete
                }
            }
            ref.current.initData(currentData);
        }

        fetchApi.GET(wmService, {
            apiId: "menuWarehouseCategory",
            apiExtend: 'getTypeList',
            apiVariable: menuWarehouseCategoryId,
        }).then(res => {
            if (res.success) {
                setMenuWarehouseTypeData(res.data)
            }
        });

        setDefaultCategoryId(menuWarehouseCategoryId);
        return false;
    }

    //导出文档
    const handleOk = (e: any) => {
        setLoadingData(true);
        form.validateFields() //数据校验
            .then(async (values: any) => {
                let res = await fetchApi.GET(wmService, {
                    apiId,
                    apiExtend: 'downloadData',
                    apiData: {
                        ...values
                    }
                })
                if (res.success) {
                    onCloseDownLoadModal();
                    setLoadingData(false);
                    if (res.data.length > 0) {
                        await DownloadExcel(res.data, "menuWarehouse");
                    }
                    else {
                        antMessage('error', '没有数据', "当前品牌和分类没有数据。");
                    }
                }
            })
    };

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '菜品智库',
        apiId,
        showImage: true,
        showUploadFile: true,
        showStates: false,
        disabledAdd: false,
        showOperation: true,
        showAdd: true,
        pagination: true,
        columns,
        EditComponent: MenuWarehouseEdit,
        arrayFilesName: 'menuWarehouseFiles',
        UploadFileComponent: MenuWarehouseUploadFile,
        sendPageData: {
            // branchStoreId: localStorage.getItem("currentBranchStoreId")
            branchStoreId: contextData?.currentBranchStoreId
        },
        mountDataOptions: {
            userMount: {
                isBranchStore: true
            }
        }
    };

    const isCompleteChange = (e: any) => {
        setIsComplete(e.target.value);
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                menuWarehouseTypeId,
                menuWarehouseCategoryId,
                opusNumberBefore,
                menuWarehouseDepartmentId,
                isComplete: e.target.value
            }
        }
        ref.current.initData(currentData);
    };

    return (
        <>
            <Modal
                title="菜式历程"
                open={historyVisible}
                okText='关闭'
                onOk={onCloseHistory}
                onCancel={onCloseHistory}
                cancelButtonProps={{ style: { display: "none" } }}
                style={{ fontSize: '20px' }}
                width={500}
            >
                <br></br>
                <br></br>
                <br></br>
                <Timeline mode='left' items={historyData} />
            </Modal>

            {/* <Popconfirm
                title="批量复制菜式到其他品牌"
                description="考虑中。。。。。。。。。。。。。。。。。"
            // onConfirm={() => handleCopy(undefined, 'all')}
            >
                <Button type="primary">复制菜式到其他品牌</Button>
            </Popconfirm> */}
            {/* <Button type="primary" onClick={() => handleCopy(undefined, 'all')}>复制菜式到其他品牌</Button> */}
            {/* <span>&nbsp;&nbsp;</span> */}

            <Modal
                title={"导出所选分类的所有菜式"}
                open={showDownLoadModalVisible}
                onOk={handleOk}
                onCancel={onCloseDownLoadModal}
                cancelButtonProps={{ disabled: loadingData }}
                okButtonProps={{ disabled: loadingData }}
                closable={false}
                maskClosable={false}
                style={{ fontSize: '20px' }}
                width={500}
            >
                <Form
                    form={form}
                    name="Edit"
                    style={{ height: 450 }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="选择品牌"
                                name="brandIds"
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    placeholder={<span style={{ color: '#DD0' }}>如不选择品牌则默认为全部品牌</span>}
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) => {
                                        return true
                                    }}
                                >
                                    {getList.general(brandData, 'brandName')}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="选择大分类"
                                name="menuWarehouseCategoryIds"
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    placeholder={<span style={{ color: '#DD0' }}>如不选择大分类则默认为全部大分类</span>}
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) => {
                                        return true
                                    }}
                                >
                                    {getList.general(menuWarehouseCategoryData, 'menuWarehouseCategoryName')}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
            <div>
                <Space>
                    <Radio.Group
                        options={isCompleteOptions}
                        onChange={isCompleteChange}
                        value={isComplete}
                        optionType="button"
                        buttonStyle="solid"
                    />

                    <Select
                        style={{ width: 150 }}
                        showSearch
                        allowClear
                        onSelect={(e) => selectChange(e, "opusNumberBefore", setOpusNumberBefore)}
                        onClear={() => selectChange(undefined, "opusNumberBefore", setOpusNumberBefore)}
                        placeholder="作品号前缀"
                        optionFilterProp="children"
                        filterOption={(input, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        options={opusNumberBefores}>
                    </Select>

                    <Select
                        style={{ width: 150 }}
                        showSearch
                        allowClear
                        onSelect={(e) => selectChange(e, "menuWarehouseCategory", setMenuWarehouseCategoryId)}
                        onClear={() => selectChange(undefined, "menuWarehouseCategory", setMenuWarehouseCategoryId)}
                        placeholder="大分类"
                        optionFilterProp="children"
                        filterOption={(input, option: any) => {
                            return true
                        }}
                    >
                        {getList.general(menuWarehouseCategoryData, 'menuWarehouseCategoryName')}
                    </Select>

                    <Select
                        style={{ width: 150 }}
                        showSearch
                        allowClear
                        value={menuWarehouseTypeValue}
                        onSelect={(e) => selectChange(e, "menuWarehouseType", setMenuWarehouseTypeId)}
                        onClear={() => selectChange(undefined, "menuWarehouseType", setMenuWarehouseTypeId)}
                        placeholder="小分类"
                        optionFilterProp="children"
                        filterOption={(input, option: any) => {
                            return true
                        }}
                    >
                        {getList.general(menuWarehouseTypeData, 'menuWarehouseTypeName')}
                    </Select>

                    <Select
                        style={{ width: 150 }}
                        showSearch
                        allowClear
                        onSelect={(e) => selectChange(e, "menuWarehouseDepartment", setMenuWarehouseDepartmentId)}
                        onClear={() => selectChange(undefined, "menuWarehouseDepartment", setMenuWarehouseDepartmentId)}
                        placeholder="出品部门"
                        optionFilterProp="children"
                        filterOption={(input, option: any) => {
                            return true
                        }}
                    >
                        {getList.general(menuWarehouseDepartmentData, 'menuWarehouseDepartmentName')}
                    </Select>
                </Space>
            </div>
            <br></br>
            <Button type="primary" onClick={handleDownloadExcel}>导出文档</Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>

            {menuWarehouseIngredientVisible
                ? (<MenuWarehouseIngredient
                    closeModal={onCloseIngredient} data={ingredientData} />)
                : null}

            {menuWarehouseSpecVisible
                ? (<MenuWarehouseSpec
                    closeModal={onCloseMenuWarehouseSpec} data={specData} />)
                : null}

            {menuMovieVisible
                ? (<MenuMovie
                    closeModal={onCloseMenuMovie} menuWarehouseId={menuWarehouseId} isModel={true} />)
                : null}

            {menuIntroductionVisible
                ? (<MenuIntroduction
                    closeModal={onCloseMenuIntroduction} data={menuIntroductionData} />)
                : null}

            {/* {copyMenuWarehouseVisible
                ? (<CopyMenuWarehouse
                    closeModal={setCopyMenuWarehouseVisible} data={copyMenuWarehouseData} />)
                : null} */}
        </>
    )
}